import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import LastPageRoundedIcon from "@mui/icons-material/LastPageRounded";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
    Button,
    Card,
    CardContent,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    styled,
    tableCellClasses,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrandStatus, ERoles } from "../../../config";
import useAuth from "../../../hooks/useAuth";
import { clearErrorMessagesOfBrands } from "../../../redux/brandManagement/brandManagementSlice";
import { getAllBrandByFilterThunk } from "../../../redux/brandManagement/brandManagementThunk";
import { apiGatewayAxiosInstance } from "../../../utils/axios";
import TablePaginationShowPage from "../../../utils/tablePagination";
import AlertMessageComponent from "../../components/AlertMessageComponent";
import FetchingSpinner from "../../components/FetchingSpinner";
import NoRecords from "../../components/NoRecords";
import StyledMenu from "../../tables/StyledMenu";
import FilterAllBrandModel from "./FilterBrandModel";
import SearchableDropdown from "../../mis/SearchableDropdown";
import RefreshButton from "../../../utils/refreshButton";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 20,
        // backgroundColor: theme.palette.common.lightBlue,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 25,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

export default function ListRoles({ handleViewBrandDetails, searchParams, setSearchParams }) {
    const state = useSelector(state => state.brandManagementSlice);
    const { user } = useAuth();
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = anchorEl?.id.split("@")[1];
    const [openFilter, setOpenFilter] = React.useState(false);
    const [activeReseller, setActiveReseller] = useState([]);
    const [selectedReseller, setSelectedReseller] = useState("");
    const [errorResponse, setErrorResponse] = useState("");
    const [reload, setReload] = useState(false);
    const [pageSize, setPageSize] = React.useState(10);

    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };
    const reloadList = () => {
        setReload(!reload);
    };
    const handleChangeRowsPerPage = event => {
        setPageSize(parseInt(event.target.value));
        setCurrentPage(0);
    };
    const handleClickOpenFilterModel = () => {
        setOpenFilter(true);
    };

    const handleCloseFilterModel = () => {
        // setSearchParams({});
        setOpenFilter(false);
    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        dispatch(
            getAllBrandByFilterThunk({
                currentPage: currentPage + 1,
                pageSize,
                searchParams,
                registryId: selectedReseller,
                roleName: user?.roleName,
            }),
        );
    }, [currentPage, pageSize, user, reload]);

    const onCloseErrorMessage = ({ fieldName }) => {
        dispatch(clearErrorMessagesOfBrands({ fieldName }));
    };
    const handleClickSearch = searchParams => {
        setCurrentPage(0);
        setPageSize(10);
        setSearchParams(searchParams);
        dispatch(
            getAllBrandByFilterThunk({
                currentPage: 1,
                pageSize: 10,
                searchParams,
                roleName: user?.roleName,
                registryId: selectedReseller,
            }),
        );
        handleCloseFilterModel();
    };

    const getActiveReseller = async () => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/user_management/reseller/get-active-reseller`);
            setActiveReseller(response.data.data);
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setErrorResponse(errorMessage);
        }
    };

    const setSelectedResellerAndGetOrgForSelectedReseller = async e => {
        try {
            const value = e.target.value;
            const registryId = value || user?.registryId;
            const isAll = registryId === "All";
            const id = isAll ? "" : registryId;
            setSelectedReseller(id);
            // setSelectedOrganization(isAll ? "All" : "");
            if (user?.roleName == ERoles.SUPER_ADMIN) {
                dispatch(
                    getAllBrandByFilterThunk({
                        currentPage: 1,
                        pageSize,
                        searchParams,
                        roleName: user?.roleName,
                        registryId: id,
                    }),
                );
            }
            setCurrentPage(0);
            setPageSize(10);
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setErrorResponse(errorMessage);
        }
    };

    useEffect(() => {
        getActiveReseller();
    }, []);

    return (
        <Grid>
            <Grid container mb={4} className="listHeader">
                <Grid item md={6}>
                    <Typography variant="h3">Brands</Typography>
                </Grid>
            </Grid>
            <Grid>
                <Card className="border border-secondary-50 ">
                    <CardContent
                        sx={{
                            padding: 0,
                        }}
                    >
                        <Grid container display={"flex"} justifyContent={"space-between"} className="text-primary align-items-center " padding={5}>
                            <Grid item display={"flex"} md={6}>
                                {user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN && (
                                    <FormControl size="small" fullWidth>
                                        <SearchableDropdown
                                            label="Select Reseller"
                                            placeholder="Reseller"
                                            name="Active Reseller"
                                            size="small"
                                            // disabled={state.activeOrgLoading}
                                            dropDownList={[...activeReseller]}
                                            value={selectedReseller || "All"}
                                            handleChange={setSelectedResellerAndGetOrgForSelectedReseller}
                                            valueKey="_id"
                                            dropDownValueKey="resellerName"
                                        />
                                    </FormControl>
                                )}
                            </Grid>
                            <Grid item md={3} justifyContent={"end"} display={"flex"}>
                                <RefreshButton loading={state.controls.isGetAllBrandsLoading} onClick={reloadList} />
                                <Button sx={{ marginRight: "10px", marginLeft: "10px"}} variant="contained" onClick={handleClickOpenFilterModel}>
                                    Filter
                                </Button>
                                {/* {user &&
                                                user.roleName.toLowerCase() !==
                                                ERoles.SUPER_ADMIN && (
                                                    <Button
                                                        variant="contained"
                                                        onClick={onClickAddRoleButton}
                                                    >
                                                        Add New Brand
                                                    </Button>
                                                )} */}
                            </Grid>
                        </Grid>
                        {state.controls.isGetAllBrandsLoading ? (
                            <FetchingSpinner />
                        ) : (
                            // tableRole ?
                            <>
                                {" "}
                                {state.brandListByPageSize?.length > 0 ? (
                                    <TableContainer component={Paper} className="table-container" sx={{ maxHeight: "60vh" }}>
                                        <Table stickyHeader aria-label="simple table">
                                            <TableHead className="p-3 mb-2 bg-secondary text-white row">
                                                <TableRow>
                                                    <StyledTableCell className="col-1 tableHeaderFont" align="center">
                                                        Sr No
                                                    </StyledTableCell>
                                                    <StyledTableCell className="col-3 tableHeaderFont" align="left">
                                                        Brand Name
                                                    </StyledTableCell>
                                                    {user?.roleName && user?.roleName === ERoles.SUPER_ADMIN && (
                                                        <StyledTableCell className="col-3 tableHeaderFont" align="left">
                                                            Reseller Name
                                                        </StyledTableCell>
                                                    )}
                                                    {user?.roleName && user?.roleName === ERoles.SUPER_ADMIN && (
                                                        <StyledTableCell className="col-3 tableHeaderFont" align="left">
                                                            Admin Email Id
                                                        </StyledTableCell>
                                                    )}
                                                    <StyledTableCell className="col-3 tableHeaderFont" align="left">
                                                        Status
                                                    </StyledTableCell>
                                                    <StyledTableCell className="col-2 tableHeaderFont" align="left">
                                                        Action
                                                    </StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {state.brandListByPageSize.map((brand, index) => (
                                                    <StyledTableRow key={index}>
                                                        <StyledTableCell className="tableContentFont" align="center">
                                                            <b>{currentPage * pageSize + index + 1}</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell className="tableContentFont" align="left">
                                                            {brand.brandName}
                                                        </StyledTableCell>
                                                        {user?.roleName && user?.roleName == ERoles.SUPER_ADMIN && (
                                                            <StyledTableCell className="tableContentFont" align="left">
                                                                {brand.resellerName ? brand.resellerName : "-"}
                                                            </StyledTableCell>
                                                        )}
                                                        {user?.roleName && user?.roleName == ERoles.SUPER_ADMIN && (
                                                            <StyledTableCell className="tableContentFont" align="left">
                                                                {brand.contactPersonDetails.emailId}
                                                            </StyledTableCell>
                                                        )}
                                                        <StyledTableCell className="tableContentFont" align="left">
                                                            <Typography
                                                                variant="subtitle2"
                                                                color={
                                                                    brand.brandStatus.toUpperCase() == BrandStatus.NotVerified
                                                                        ? "error"
                                                                        : brand.brandStatus.toUpperCase() == BrandStatus.UnderReview
                                                                        ? "orange"
                                                                        : "green"
                                                                }
                                                            >
                                                                {brand.brandStatus.replaceAll("_", " ").toUpperCase()}
                                                            </Typography>
                                                        </StyledTableCell>
                                                        <StyledTableCell className="tableContentFont" align="left">
                                                            <IconButton
                                                                id={`menu-button@${brand._id}`}
                                                                aria-controls={open === brand._id ? `customized-menu@${brand._id}` : undefined}
                                                                aria-haspopup="true"
                                                                aria-expanded={open === brand._id ? "true" : undefined}
                                                                variant="contained"
                                                                // disableElevation
                                                                onClick={handleClick}
                                                            >
                                                                <MoreVertIcon />
                                                            </IconButton>

                                                            <StyledMenu
                                                                id={`customized-menu@${brand._id}`}
                                                                MenuListProps={{
                                                                    "aria-labelledby": `menu-button@${brand._id}`,
                                                                }}
                                                                anchorEl={anchorEl}
                                                                open={open === brand._id}
                                                                onClose={handleClose}
                                                            >
                                                                <MenuItem
                                                                    onClick={() => {
                                                                        handleViewBrandDetails(brand);
                                                                    }}
                                                                >
                                                                    <IconButton title="View Details">
                                                                        <VisibilityIcon className="text-primary" />
                                                                    </IconButton>
                                                                    View Details
                                                                </MenuItem>
                                                            </StyledMenu>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <Grid></Grid>
                                    </TableContainer>
                                ) : (
                                    <NoRecords />
                                )}{" "}
                            </>
                            // )
                            // : (
                            //     <>
                            //         {state.listOfBrandBySuperAdmin.length > 0 ? (
                            //             <TableContainer
                            //                 component={Paper}
                            //                 className="table-container"
                            //             >
                            //                 <Table
                            //                     stickyHeader
                            //                     aria-label="simple table"
                            //                 >
                            //                     <TableHead className="p-3 mb-2 bg-secondary text-white row">
                            //                         <TableRow>
                            //                             <StyledTableCell
                            //                                 className="col-1 tableHeaderFont"
                            //                                 align="center"
                            //                             >
                            //                                 Sr No
                            //                             </StyledTableCell>
                            //                             <StyledTableCell
                            //                                 className="col-5 tableHeaderFont"
                            //                                 align="left"
                            //                             >
                            //                                 Brands Name
                            //                             </StyledTableCell>
                            //                             <StyledTableCell
                            //                                 className="col-3 tableHeaderFont"
                            //                                 align="left"
                            //                             >
                            //                                 Status
                            //                             </StyledTableCell>
                            //                             {/* <StyledTableCell
                            //     className="col-2 tableHeaderFont"
                            //     align="left"
                            //   >
                            //     Action
                            //   </StyledTableCell> */}
                            //                         </TableRow>
                            //                     </TableHead>
                            //                     <TableBody>
                            //                         {state.listOfBrandBySuperAdmin.map(
                            //                             (brand, index) => (
                            //                                 <StyledTableRow
                            //                                     key={index}
                            //                                 >
                            //                                     <StyledTableCell
                            //                                         className="tableContentFont"
                            //                                         align="center"
                            //                                     >
                            //                                         {currentPage *
                            //                                             10 +
                            //                                             index +
                            //                                             1}
                            //                                     </StyledTableCell>
                            //                                     <StyledTableCell
                            //                                         className="tableContentFont"
                            //                                         align="left"
                            //                                     >
                            //                                         {
                            //                                             brand.brandName
                            //                                         }
                            //                                     </StyledTableCell>
                            //                                     <StyledTableCell
                            //                                         className="tableContentFont"
                            //                                         align="left"
                            //                                     >
                            //                                         <Chip
                            //                                             variant="outlined"
                            //                                             className="chip"
                            //                                             label={
                            //                                                 brand.brandStatus
                            //                                             }
                            //                                             color={
                            //                                                 brand.brandStatus ===
                            //                                                 "Not Verified"
                            //                                                     ? "error"
                            //                                                     : "info"
                            //                                             }
                            //                                         />
                            //                                     </StyledTableCell>
                            //                                     {/* <StyledTableCell
                            //         className="tableContentFont"
                            //         align="left"
                            //       >
                            //         <IconButton
                            //           id={`menu-button@${brand._id}`}
                            //           aria-controls={
                            //             open ===
                            //               brand._id
                            //               ? `customized-menu@${brand._id}`
                            //               : undefined
                            //           }
                            //           aria-haspopup="true"
                            //           aria-expanded={
                            //             open ===
                            //               brand._id
                            //               ? "true"
                            //               : undefined
                            //           }
                            //           variant="contained"
                            //           disableElevation
                            //           onClick={
                            //             handleClick
                            //           }
                            //         >
                            //           <MoreVertIcon />
                            //         </IconButton>

                            //         <StyledMenu
                            //           id={`customized-menu@${brand._id}`}
                            //           MenuListProps={{
                            //             "aria-labelledby": `menu-button@${brand._id}`,
                            //           }}
                            //           anchorEl={
                            //             anchorEl
                            //           }
                            //           open={
                            //             open ===
                            //             brand._id
                            //           }
                            //           onClose={
                            //             handleClose
                            //           }
                            //         >
                            //           <MenuItem
                            //             onClick={() => {
                            //               handleViewBrandDetails(
                            //                 brand
                            //               );
                            //             }}
                            //           >
                            //             <IconButton title="View Details">
                            //               <VisibilityIcon className="text-primary" />
                            //             </IconButton>
                            //             View
                            //             Details
                            //           </MenuItem>
                            //         </StyledMenu>
                            //       </StyledTableCell> */}
                            //                                 </StyledTableRow>
                            //                             )
                            //                         )}
                            //                     </TableBody>
                            //                 </Table>
                            //                 <Grid></Grid>
                            //             </TableContainer>
                            //         ) : (
                            //             <NoRecords />
                            //         )}
                            //     </>
                        )}
                        {state.totalBrandsCount > 0 && (
                            <Grid
                                className="my-2"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    paddingLeft: 10,
                                }}
                            >
                                <Grid
                                    style={{
                                        marginTop: "15px",
                                        padding: 5,
                                    }}
                                >
                                    Total Brands: {state.totalBrandsCount}
                                </Grid>

                                {/* <TablePagination
                                    count={
                                        state.totalBrandsCount
                                        /// rowsPerPage
                                    }
                                    component='Grid'
                                    variant='outlined'
                                    color='primary'
                                    page={currentPage - 1}
                                    // onChange={handlePageChange}
                                    onPageChange={handleChangePage}
                                    rowsPerPage={pageSize}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                /> */}

                                {/* <TablePaginationShowPage
                                    rowsPerPageOptions={[5, 10, 25, 100]}
                                    colSpan={3}
                                    count={state.totalBrandsCount}
                                    rowsPerPage={pageSize}
                                    page={currentPage - 1}
                                    slotProps={{
                                        select: {
                                            "aria-label": "Rows per page",
                                        },
                                        actions: {
                                            showFirstButton: true,
                                            showLastButton: true,
                                            slots: {
                                                firstPageIcon: FirstPageRoundedIcon,
                                                lastPageIcon: LastPageRoundedIcon,
                                                nextPageIcon: ChevronRightRoundedIcon,
                                                backPageIcon: ChevronLeftRoundedIcon,
                                            },
                                        },
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                /> */}
                                <TablePaginationShowPage
                                    rowsPerPageOptions={[5, 10, 25, 100]}
                                    colSpan={3}
                                    count={state.totalBrandsCount}
                                    rowsPerPage={pageSize}
                                    page={currentPage}
                                    slotProps={{
                                        select: {
                                            "aria-label": "Rows per page",
                                        },
                                        actions: {
                                            showFirstButton: true,
                                            showLastButton: true,
                                            slots: {
                                                firstPageIcon: FirstPageRoundedIcon,
                                                lastPageIcon: LastPageRoundedIcon,
                                                nextPageIcon: ChevronRightRoundedIcon,
                                                backPageIcon: ChevronLeftRoundedIcon,
                                            },
                                        },
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Grid>
                        )}
                    </CardContent>

                    <AlertMessageComponent
                        message={state.controls.listAllBrandsByPageSizeErrorMessage}
                        fieldName={"listAllBrandsByPageSizeErrorMessage"}
                        handleClose={onCloseErrorMessage}
                        show={Boolean(state.controls.listAllBrandsByPageSizeErrorMessage)}
                    />
                    {openFilter && (
                        <FilterAllBrandModel
                            open={openFilter}
                            searchParams={searchParams}
                            handleClickOpenFilterModel={handleClickOpenFilterModel}
                            handleCloseFilterModel={handleCloseFilterModel}
                            setSearchParams={setSearchParams}
                            handleClickSearch={handleClickSearch}
                        />
                    )}
                </Card>
            </Grid>
        </Grid>
    );
}
